import { render, staticRenderFns } from "./ListCorrespondencias.vue?vue&type=template&id=56f13ea6&"
import script from "./ListCorrespondencias.vue?vue&type=script&lang=js&"
export * from "./ListCorrespondencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports